var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMarkerGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 40,
    viewBox: "0 0 28 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5602 39.9999C13.5002 39.8799 13.4602 39.7499 13.3902 39.6399C9.73016 34.3699 6.07016 29.0999 2.43016 23.8099C1.12016 21.9099 0.420156 19.7899 0.140156 17.5099C-0.219844 14.5799 0.120156 11.7299 1.32016 9.01993C3.25016 4.66993 6.62016 2.05993 11.2802 1.22993C15.8302 0.419933 19.8202 1.69993 23.1702 4.88993C25.0602 6.68993 26.2002 8.94993 26.7902 11.4699C27.7402 15.5199 27.4102 19.4499 25.2902 23.0899C24.3002 24.7799 23.0902 26.3499 21.9802 27.9699C19.2802 31.8699 16.5802 35.7699 13.8802 39.6699C13.8102 39.7699 13.7802 39.8899 13.7302 39.9999C13.6602 39.9999 13.6102 39.9999 13.5602 39.9999ZM9.28016 14.5099C9.28016 16.9899 11.2802 18.9799 13.7602 18.9899C16.2502 18.9899 18.2802 16.9899 18.2802 14.4999C18.2802 12.0299 16.2402 9.98993 13.7702 9.98993C11.2802 9.99993 9.27016 12.0199 9.28016 14.5099Z",
    fill: "#04A96D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarkerGreen);
export default __webpack_public_path__ + "static/media/marker-green.ca8057cbbaaf0027479a98b7ec8b7d4a.svg";
export { ForwardRef as ReactComponent };